import Vue from 'vue'

import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const PESharedDocumentActions = {
  peResetPartyDocuments: ({ commit }) => {
    commit('peSetPartyDocuments', [])
  },
  peFetchPartyDocuments: async ({ commit, getters }) => {
    const party = getters.peParty

    return axiosRequest.get(`/parties/${party.id}/party_documents`).
      then(({ data }) => {
        commit('peSetPartyDocuments', data || [])
      }).
      catch(handleError)
  },

  peUploadPartyDocument: async ({ commit, getters }, document) => {
    const party = getters.peParty

    const formData = new FormData()
    formData.append('document', document.document, document.filename)
    formData.append('document_type', document.document_type)
    formData.append('party_id', party.id)
    formData.append('notes', document.notes)
    formData.append('identifier', document.identifier)

    return axiosRequest.post(`/parties/${party.id}/party_documents`, formData).
      then(({ data }) => {
        commit('peSetPartyDocuments', data || [])
      }).
      catch(handleError)
  },

  peDeletePartyDocument: async ({ dispatch, getters }, document) => {
    const party = getters.peParty

    return axiosRequest.delete(`/parties/${party.id}/party_documents/${document.id}`).
      then(_ => { dispatch('peFetchPartyDocuments') }).
      catch(handleError)
  },
}
export const PESharedDocumentGetters = {
  pePartyDocuments: state => state.partyEdit.partyDocuments || [],
  pePartyDocumentsByIdentifier: state => {
    return (identifier, partyId) => {
      return state.partyEdit.partyDocuments.filter(doc => {
        return doc.documents_parties.find(dp => dp.identifier === identifier && dp.party_id === partyId) && doc.document
      })
    }
  },
}

export const PESharedDocumentMutations = {
  peSetPartyDocuments: (state, documents) => { Vue.set(state.partyEdit, 'partyDocuments', documents || []) },
}
